export default {
    GET_SELECT_AGENT:(state)=>{
        return state.selectAgent
    },
    GET_RESULT:(state)=>{
        return state.Result
    },
    GET_EDIT_AGENT:(state)=>{
        return state.editAgent
    },
}
